import {
    FeeTypeName,
    FeeTypeExampleData,
    FeeTypeExampleVersionData,
    CreateFeeTypeExampleRequest,
    UpdateFeeTypeExampleRequest,
    ActivateFeeTypeExampleVersionRequest
} from 'src/model/FeeTypeExample';
import ApiUtil, { HTTP_METHOD, ApiError } from './ApiUtil';
import { API } from 'aws-amplify';

class FeeTypeExampleApiUtil {

    private static async postData(resource: string, body: any): Promise<any> {
        const url = `/api/${resource}?locale=en-US`;
        
        const headers = {
            'anti-csrftoken-a2z': '',
            'content-type': 'application/json; charset=UTF-8'
        };

        const config = {
            headers: headers,
            response: true,
            body: body
        };

        try {
            const response = await API.post("FeeTechPortalLambda", url, config);
            return response.data;
        } catch (error: any) {
            throw new ApiError(error.response?.status || 500, error.response?.data?.message || error.message);
        }
    }

    private static async putData(resource: string, body: any): Promise<any> {
        const url = `/api/${resource}?locale=en-US`;
        
        const headers = {
            'anti-csrftoken-a2z': '',
            'content-type': 'application/json; charset=UTF-8'
        };

        const config = {
            headers: headers,
            response: true,
            body: body
        };

        try {
            const response = await API.put("FeeTechPortalLambda", url, config);
            return response.data;
        } catch (error: any) {
            throw new ApiError(error.response?.status || 500, error.response?.data?.message || error.message);
        }
    }

    private static async deleteData(resource: string): Promise<any> {
        const url = `/api/${resource}?locale=en-US`;
        
        const headers = {
            'anti-csrftoken-a2z': '',
            'content-type': 'application/json; charset=UTF-8'
        };

        const config = {
            headers: headers,
            response: true
        };

        try {
            const response = await API.del("FeeTechPortalLambda", url, config);
            return response.data;
        } catch (error: any) {
            throw new ApiError(error.response?.status || 500, error.response?.data?.message || error.message);
        }
    }

    static async getFeeTypeExampleKeys(): Promise<FeeTypeName[]> {
        const resource = `fee-type-examples/keys`;
        const response = await ApiUtil.callApiWithTimeout(resource, {}, 30000, HTTP_METHOD.GET);
        return response.feeTypeKeys || [];
    }

    static async getFeeTypeExample(feeType: string): Promise<FeeTypeExampleData> {
        const resource = `fee-type-examples/type/${encodeURIComponent(feeType)}`;
        const response = await ApiUtil.callApiWithTimeout(resource, {}, 30000, HTTP_METHOD.GET);
        return response.feeTypeExample;
    }

    static async createFeeTypeExample(request: CreateFeeTypeExampleRequest): Promise<FeeTypeExampleData> {
        const resource = `fee-type-examples/type/${encodeURIComponent(request.feeType)}`;
        const body = { examples: request.examples };
        const response = await FeeTypeExampleApiUtil.postData(resource, body);
        return response.feeTypeExample;
    }

    static async updateFeeTypeExample(request: UpdateFeeTypeExampleRequest): Promise<FeeTypeExampleData> {
        const resource = `fee-type-examples/type/${encodeURIComponent(request.feeType)}`;
        const body = { examples: request.examples };
        const response = await FeeTypeExampleApiUtil.putData(resource, body);
        return response.feeTypeExample;
    }

    static async deleteFeeTypeExample(feeType: string): Promise<void> {
        const resource = `fee-type-examples/type/${encodeURIComponent(feeType)}`;
        await FeeTypeExampleApiUtil.deleteData(resource);
    }

    static async getFeeTypeExampleVersions(feeType: string): Promise<FeeTypeExampleVersionData[]> {
        const resource = `fee-type-examples/type/${encodeURIComponent(feeType)}/versions`;
        const response = await ApiUtil.callApiWithTimeout(resource, {}, 30000, HTTP_METHOD.GET);
        return response.versions || [];
    }

    static async activateFeeTypeExampleVersion(request: ActivateFeeTypeExampleVersionRequest): Promise<FeeTypeExampleData> {
        const resource = `fee-type-examples/type/${encodeURIComponent(request.feeType)}/activate`;
        const body = { versionId: request.versionId };
        const response = await FeeTypeExampleApiUtil.postData(resource, body);
        return response.feeTypeExample;
    }
}

export default FeeTypeExampleApiUtil;
